// src/components/chart10.js
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  ReferenceLine,
} from "recharts";

const RTBarChartWithStdLine = ({ data = [], title = "", stdValue = null }) => {
  const showLine = Number.isFinite(Number(stdValue));

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <div
        style={{
          color: "#ffffff",
          fontWeight: 800,
          marginBottom: 8,
          textAlign: "center",
        }}
      >
        {title}
      </div>

      <div style={{ width: "100%", height: "calc(100% - 32px)" }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            {/* Grid más suave */}
            <CartesianGrid stroke="#555" strokeDasharray="3 3" />

            {/* Letras blancas */}
            <XAxis dataKey="name" tick={{ fill: "#ffffff" }} />
            <YAxis tick={{ fill: "#ffffff" }} />

            {/* Tooltip oscuro */}
            <Tooltip
              contentStyle={{
                backgroundColor: "#1f2937",
                border: "none",
                borderRadius: "8px",
                color: "#fff",
              }}
              labelStyle={{ color: "#fff" }}
            />

            {/* Línea estándar */}
            {showLine && (
              <ReferenceLine
                y={Number(stdValue)}
                stroke="#facc15"
                strokeWidth={2}
                strokeDasharray="6 6"
                label={{
                  value: `STD ${Number(stdValue).toFixed(0)}`,
                  position: "right",
                  fill: "#facc15",
                  fontSize: 12,
                }}
              />
            )}

            {/* Barras */}
            <Bar
              dataKey="value"
              fill="#0084ff"
              radius={[6, 6, 0, 0]} // bordes redondeados arriba
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RTBarChartWithStdLine;
